import { render } from "./pictcarousel.vue?vue&type=template&id=1fd04a4d&scoped=true"
import script from "./pictcarousel.vue?vue&type=script&lang=js"
export * from "./pictcarousel.vue?vue&type=script&lang=js"

import "./pictcarousel.vue?vue&type=style&index=0&id=1fd04a4d&lang=scss&scoped=true"
import "./pictcarousel.vue?vue&type=style&index=1&id=1fd04a4d&lang=scss"
script.render = render
script.__scopeId = "data-v-1fd04a4d"

export default script